import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import PropertyLocation from '../components/PropertyLocation';
import Information from '../components/Information';
import * as actions from '../action';
import * as c from '../constant';
import MachineryHistoryContainer from '../components/machine-history/container/MachineryHistoryContainer';
import MachineryTransactionsContainer from '../components/machinery-transactions/container/MachineryTransactionsContainer';
import MachinerySupersededAssessmentContainer from '../components/machinery-superseded-assessment/container/MachinerySupersededAssessmentContainer';
import MachineryPropertyAssessmentContainer from '../components/machinery-property-assessment/container/MachineryPropertyAssessmentContainer';
import MachineryAppraisalContainer from '../components/machinery-appraisal/container/MachineryAppraisalContainer';
import TransactionModal from '../modals/TransactionModal';
import PaymentHistory from '../components/machine-payment-history/container/PaymentHistory';
import ViewLogsModal from '../modals/ViewLogsModal';

function MachineryApplicationContent({
  applicationId,
  getSingleMachineryApplication,
  applicationInfo,
  handleEdit,
  permissions,
  listIsLoading,
  applicationInfoIsLoading,
  postMachineryApplication,
  unpostMachineryApplication,
  getMachineryApplicationsList,
  revertMachineryApplication,
}) {
  const [activeTab, setActiveTab] = useState(1);
  const [formData, setFormData] = useState({
    scroll: 0,
  });
  const scrollref = React.createRef();
  const setModal = useContext(ModalContext);

  const isApprovalEmpty =
    _.isEmpty(applicationInfo, 'attributes.appraised_assessed_by_id') ||
    _.isEmpty(applicationInfo, 'attributes.recommending_by_id') ||
    _.isEmpty(applicationInfo, 'attributes.approved_by_id');

  const handleActivePage = (index) => () => {
    setActiveTab(index);
  };

  const scrollToLeft = (e) => {
    e.preventDefault();
    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const val = formData.scroll - slide < 0 ? 0 : formData.scroll - slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  const scrollToRight = (e) => {
    e.preventDefault();

    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const calculatedWidth = width - slide;
    const val =
      formData.scroll + slide > calculatedWidth
        ? calculatedWidth
        : formData.scroll + slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  const handleTransaction = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TransactionModal />,
      title: 'Transaction',
      modalSize: 'modal-md',
      modalContentSize: 'custom-size',
    });
  };

  const handlePostModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to post this application?',
      () => {
        postMachineryApplication(data?.id, () => {
          getMachineryApplicationsList();
          getSingleMachineryApplication(data.id);
        });
      },
      false,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleUnpostModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to unpost this application?',
      (remarks) => {
        unpostMachineryApplication(data?.id, { remarks }, () => {
          getMachineryApplicationsList();
          getSingleMachineryApplication(data.id);
        });
      },
      false,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleRevert = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to revert this application?',
      () => {
        revertMachineryApplication(data?.id, () => {
          getMachineryApplicationsList();
          getSingleMachineryApplication(data.id);
        });
      },
      false,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      false
    );
  };

  const handleViewLogs = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewLogsModal data={data} />,
      title: 'Machinery Application Logs',
      modalSize: 'modal-lg',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getSingleMachineryApplication(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getSingleMachineryApplication(applicationId);
  }, [applicationId]);

  return (
    <div className="d-flex flex-column h-100">
      {Acl(permissions, ['CREATE E2E RPT MACHINERY APPLICATIONS']) && (
        <div className="row mb-3">
          <div className="ml-auto">
            <button
              type="button"
              onClick={handleTransaction}
              className="d-flex align-items-center justify-content-center btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
              style={{ marginRight: 30 }}
            >
              Transaction
            </button>
          </div>
        </div>
      )}
      <div className="ml-3 p-3 card right-section h-100">
        <div className="d-flex mb-3">
          <div className="d-flex w-100 justify-content-between align-items-center">
            <h3 className="mb-0">
              <b>{_.get(applicationInfo, 'attributes.tdn')}</b>
            </h3>
            <div className="d-flex">
              {Acl(permissions, ['POST E2E RPT MACHINERY APPLICATIONS']) &&
                ['PENDING', 'FOR_APPRAISAL', 'FOR_REASSESSMENT'].indexOf(
                  _.get(applicationInfo, 'attributes.status')
                ) > -1 &&
                (_.get(
                  applicationInfo,
                  'included.transactionCode.attributes.code'
                ) !== 'TR' ||
                  !isApprovalEmpty) && (
                  <div className="mr-2">
                    <button
                      type="button"
                      onClick={handlePostModal(applicationInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                    >
                      Post&nbsp;
                    </button>
                  </div>
                )}
              {Acl(permissions, ['UPDATE E2E RPT MACHINERY APPLICATIONS']) &&
                ['PENDING', 'FOR_APPRAISAL', 'FOR_REASSESSMENT'].indexOf(
                  _.get(applicationInfo, 'attributes.status')
                ) > -1 && (
                  <div>
                    <button
                      type="button"
                      onClick={handleEdit(applicationInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                    >
                      Edit&nbsp;
                    </button>
                  </div>
                )}
              {Acl(permissions, ['UNPOST E2E RPT MACHINERY APPLICATIONS']) &&
                _.get(applicationInfo, 'attributes.status') === 'POSTED' && (
                  <div className="ml-2">
                    <button
                      type="button"
                      onClick={handleUnpostModal(applicationInfo)}
                      className="btn btn-danger cms-bg-color-danger cms-outline-danger  font-weight-bold px-4 ml-auto"
                    >
                      Unpost&nbsp;
                    </button>
                  </div>
                )}
              {Acl(permissions, ['REVERT E2E RPT MACHINERY APPLICATIONS']) &&
                ['CANCELLED'].indexOf(
                  _.get(applicationInfo, 'attributes.status')
                ) > -1 && (
                  <div className="ml-2">
                    <button
                      type="button"
                      onClick={handleRevert(applicationInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    >
                      Revert&nbsp;
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            onClick={handleViewLogs(applicationInfo)}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
          >
            Logs&nbsp;
          </button>
        </div>
        {!_.isEmpty(applicationInfo) ? (
          <>
            <div className="page-submenu d-flex justify-content-between align-content-center">
              <button
                type="button"
                className="tab-arrow left"
                onClick={scrollToLeft}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className={`fa fa-caret-left ${
                    +formData.scroll === 0 ? 'd-none' : ''
                  }`}
                />
              </button>
              <ul
                className="tab-list tab-scroll no-border scroll"
                ref={scrollref}
              >
                {Acl(permissions, ['E2E RPT TREASURY']) === true &&
                  Acl(permissions, ['E2E RPT ASSESSOR']) === false && (
                    <>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 1 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(1)}
                        >
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 2 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(2)}
                        >
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 3 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(3)}
                        >
                          Machinery Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 4 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(4)}
                        >
                          Property Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 5 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(5)}
                        >
                          Superseded Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 6 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(6)}
                        >
                          Transaction
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 7 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(7)}
                        >
                          History
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 8 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(8)}
                        >
                          Payment History
                        </button>
                      </li>
                    </>
                  )}
                {Acl(permissions, ['E2E RPT TREASURY']) &&
                  Acl(permissions, ['E2E RPT ASSESSOR']) && (
                    <>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 1 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(1)}
                        >
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 2 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(2)}
                        >
                          Information
                        </button>
                      </li>

                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 3 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(3)}
                        >
                          Machinery Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 4 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(4)}
                        >
                          Property Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 5 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(5)}
                        >
                          Superseded Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 6 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(6)}
                        >
                          Transaction
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 7 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(7)}
                        >
                          History
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 8 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(8)}
                        >
                          Payment History
                        </button>
                      </li>
                    </>
                  )}
                {Acl(permissions, ['E2E RPT TREASURY']) === false &&
                  Acl(permissions, ['E2E RPT ASSESSOR']) === true && (
                    <>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 1 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(1)}
                        >
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 2 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(2)}
                        >
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 4 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(4)}
                        >
                          Property Assessment
                        </button>
                      </li>
                    </>
                  )}
              </ul>
              <button
                type="button"
                className="tab-arrow right"
                onClick={scrollToRight}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className={`fa fa-caret-right ${
                    +formData.totalwidth === +formData.rightdistance
                      ? 'd-none'
                      : ''
                  }`}
                />
              </button>
            </div>
            <div className="tabs-details">
              {activeTab === 1 && <PropertyLocation data={applicationInfo} />}
              {activeTab === 2 && <Information data={applicationInfo} />}
              {activeTab === 3 && (
                <MachineryAppraisalContainer
                  applicationId={applicationInfo.id}
                />
              )}
              {activeTab === 4 && (
                <MachineryPropertyAssessmentContainer
                  applicationId={applicationInfo.id}
                />
              )}
              {activeTab === 5 && (
                <MachinerySupersededAssessmentContainer
                  applicationId={applicationInfo.id}
                />
              )}
              {activeTab === 6 && (
                <MachineryTransactionsContainer
                  applicationId={applicationInfo.id}
                />
              )}
              {activeTab === 7 && (
                <MachineryHistoryContainer applicationId={applicationInfo.id} />
              )}
              {activeTab === 8 && (
                <PaymentHistory applicationId={applicationInfo.id} />
              )}
            </div>
          </>
        ) : (
          <>
            {listIsLoading && applicationInfoIsLoading ? (
              <div
                className="text-center mt-5"
                style={{
                  position: 'absolute',
                  zIndex: 5,
                  left: 0,
                  right: 0,
                  margin: '100px auto',
                  width: 40,
                  height: 40,
                  background: '#eaeaea',
                  borderRadius: '50%',
                  paddingTop: 6,
                  fontWeight: 'bolder',
                  fontSize: 20,
                }}
              >
                <span className="fas fa-1x fa-spin fa-spinner" />
              </div>
            ) : (
              <div className="d-flex align-items-center justitfy-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0"> No Item Found </p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

MachineryApplicationContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  getSingleMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  applicationInfo: PropTypes.instanceOf(Object).isRequired,
  applicationId: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
  listIsLoading: PropTypes.bool.isRequired,
  applicationInfoIsLoading: PropTypes.bool.isRequired,
  postMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  unpostMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  getMachineryApplicationsList: PropTypes.instanceOf(Function).isRequired,
  revertMachineryApplication: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  applicationInfo:
    _.get(api, `${c.GET_SINGLE_MACHINERY_APPLICATION}.item`) || {},
  applicationId: _.get(match, 'params.applicationId') || '',
  permissions: getJson('permissions'),
  applicationInfoIsLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_APPLICATIONS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryApplicationContent);
